import { FilterMap } from '../../../app/state/ContentExplorerState';
import { TopLevelProjectId } from '../../../app/state/SpaceInfo';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { ContentFiltersKeys } from '../ContentFilters';
import { NavLocationSelectors } from '../../../app/selectors/NavigationStateSelectors';
import { getAppStore } from '../../../app/AppStore';
import { nonSystemJobFilter } from '../../../backgroundJob/types/IBackgroundJob';
import { Filter } from '../../helpers/Filter';
import { FilterFieldNames } from '../../ServerApi/types/IFilterClause';
import {getSessionManagementServiceInstance} from '../../../sessionManagement/SessionManagementService';

// TODO: Refactor this with SpaceInfo
export function getGenericDefaultFilters(projectId: string) {
  let filterMap: FilterMap = {};
  if (projectId !== TopLevelProjectId) {
    filterMap[ContentFiltersKeys.project] = ServerFilterClauses.create({ project: projectId })[0];
  }
  return filterMap;
}

export function getNoDefaultFilters(_projectId: string) {
  return {};
}

export function getDataSourceDefaultFilters(projectId: string) {
  let filterMap: FilterMap = getGenericDefaultFilters(projectId);
  filterMap[ContentFiltersKeys.showEmbedded] = ServerFilterClauses.serverFilterClauses[ContentFiltersKeys.showEmbedded]('false');
  return filterMap;
}

export function getDataConnectionDefaultFilters(projectId: string): FilterMap {
  let filterMap: FilterMap = getDataSourceDefaultFilters(projectId);

  // Since, in the current UX, data connections are listed under the data sources tab,
  // data connections should always be filtered to those contained by a data source
  // (not those contained by a flow), whether flows are enabled or not.
  filterMap[ContentFiltersKeys.containerType] = ServerFilterClauses.create({containerType: 'datasource'})[0];

  return filterMap;
}

export function getBackgroundJobsDefaultFilters(projectId: string) {
  const serverService = getSessionManagementServiceInstance();
  const isServerPage = NavLocationSelectors.inServerArea(getAppStore().getState());

  return {
    backgroundJobTaskType: nonSystemJobFilter,
    siteId: isServerPage ? undefined : Filter.stringFieldEq(FilterFieldNames.siteId, serverService.sessionSiteId())
  };
}
